export interface IFunctionsItems {
  label: string;
  disabled?: boolean;
  route?: string;
  userType?: 'admin' | 'client';
  title: string;
}
export const TargetInfortmation: IFunctionsItems[] = [
  {
    title: 'Identificação da atividade',
    label:
      'Aqui você insere um nome curto para identificação da atividade. É o “título” do seu formulário ROPA.',
  },
  {
    title: 'Responsável pela atividade',
    label:
      'Aqui deve ser indicada a pessoa responsável por essa atividade, ou seja, a pessoa que supervisiona ou lidera essa operação e poderá responder dúvidas sobre ela.',
  },
  {
    title: 'Descrição da atividade',
    label:
      'Uma atividade de tratamento de dados pessoais é qualquer ação, projeto, atividade, operação que envolva dados pessoais. Ex. Contratação de novos colaboradores, envio de e-mail marketing, processamento de folha de pagamentos, troca de e-mails com clientes, processamentos de compras, etc. Aqui você deve descrever o que é a atividade que você quer mapear e como ela funciona. Importante: nessa etapa é importante evitar a utilização de siglas, acrônimos ou nomes de sistemas sem a devida explicação.',
  },
  {
    title: 'Área responsável pela atividade',
    label:
      'Aqui deve ser indicada a área da pessoa responsável por essa atividade. Ex. RH, Marketing, Financeiro, etc.',
  },
  {
    title: 'Qual a finalidade da atividade?',
    label:
      'Aqui você deve descrever o objetivo da atividade mapeada. Por que ela é realizada? Qual é a sua finalidade? O que se deseja alcançar com ela?',
  },
  {
    title: 'Quais são os dados envolvidos nessa atividade?',
    label:
      'Aqui você deve listar todos os tipos de dados pessoais que são tratados nessa atividade. Importante ressaltar que se trata dos tipos de dados e não dos dados em si. É preciso evitar termos genéricos ou que, por algum motivo, não deem visibilidade sobre os dados sob tratamento, como `identificadores de pessoa física`. O que são dados pessoais? - Dados pessoais são quaisquer informações que individualizem ou possam individualizar uma pessoa física. Isso inclui informações financeiras, históricos ou registros de compras, ou interações, registros eletrônicos, dados sobre comportamento, ou até mesmo opinião. Ex. Nome, e-mail (mesmo que seja e-mail profissional), histórico profissional, perfil de consumo ou de comportamento, etc.Fique atento - Número de MEI ou EIRELI, por mais que determinem pessoas jurídicas, identificam pessoas físicas diretamente e por isso são considerados dados pessoais.',
  },
];
export const BasicInformations: IFunctionsItems[] = [
  {
    title: 'Quem são os controladores dessa atividade?',
    label:
      'Aqui você deverá indicar quem é o responsável por tomar as decisões sobre as finalidades e os meios do tratamento de dados. Atenção: uma área ou um funcionário em uma empresa não podem ser controladores. Nesses casos, o controlador é a empresa em si. Caso esteja na dúvida, indique nas observações ou realize o Teste Operador Controlador aqui no DPO HUB, dentro de “Avaliação de Terceiros”.',
  },
  {
    title: 'Quem são os operadores nessa atividade?',
    label:
      'Aqui você deverá indicar se existem operadores, ou seja, pessoas físicas ou jurídicas responsáveis por tratar os dados pessoais conforme as instruções do controlador, e identificá-las. Caso esteja na dúvida, indique nas observações ou realize o Teste Operador Controlador aqui no DPO HUB, dentro de “Avaliação de Terceiros”. Lembrando: o controlador é o responsável por tomar as decisões sobre as finalidades e os meios do tratamento de dados.',
  },
  {
    title: 'Quais os titulares?',
    label:
      'Aqui listar os tipos de titulares envolvidos na atividade. Importante ressaltar que se trata dos tipos de titulares e não a identificação dos titulares em si. Titulares de dados são as pessoas físicas a quem se referem os dados pessoais que estão sendo tratados. Por exemplo: endereço de e-mail é um dado pessoal – o titular é a pessoa que usa o endereço de e-mail. O número de CPF é um dado pessoal – o titular é a pessoa a qual esse número está vinculado. Ex. Funcionários, clientes, diretores.',
  },
  {
    title: 'De onde vêm os dados?',
    label:
      'Aqui indicar a fonte desses dados pessoais. Como você tem acesso a eles? Ex. são entregues pelos próprios titulares, são compartilhados por meio de um terceiro, são coletados em um site, etc.',
  },
  {
    title: 'Os dados são compartilhados com terceiros ou outras áreas?',
    label:
      'Aqui indicar se os dados pessoais envolvidos na atividade são compartilhados com terceiros externos à sua instituição ou com outras áreas internas que não, a área responsável indicada na primeira página do formulário. Apenas responder “sim” ou “não”.',
  },
  {
    title: 'Com quem são compartilhados?',
    label:
      'Aqui indicar quaisquer terceiros externos ou com outras áreas internas que não, a área responsável com os quais os dados pessoais são compartilhados.',
  },
  {
    title: 'Link para contrato com Operadores:',
    label:
      'Caso a atividade envolva terceiro externo que trata dados pessoas sob instruções e decisões da sua instituição, indicar aqui onde é possível acessar o contrato que rege essa relação.',
  },
  {
    title: 'Os dados são armazenados ou enviados para outros países?',
    label:
      'Indicar se ocorre transferência internacional de dados pessoais, seja enviando, armazenando ou coletando esses dados fora do país. Pode ser por meio de um fornecedor, um correspondente, um servidor estrangeiro, etc. ',
  },
  {
    title: 'Por quanto tempo os dados são armazenados?',
    label:
      'Aqui indicar por quanto tempo os dados pessoais são armazenados pela sua instituição. Se não existir nenhuma política de exclusão de dados e os dados forem armazenados por tempo indefinido, por favor indicar indefinido.',
  },
  {
    title:
      'Quais são as medidas de segurança técnicas e administrativas empregadas nesta atividade?',
    label:
      'Medidas de segurança técnicas são aquelas ligadas à segurança da informação, como um sistema anti-vírus, um controle de acessos eletrônico, etc. Medidas de segurança administrativas são aquelas ligadas a políticas sobre o ambiente de trabalho e o comportamento dos colaboradores, como políticas de mesa limpa, treinamentos, etc.',
  },
];

export const AditionalInformation: IFunctionsItems[] = [
  {
    title: 'Qual é a base legal dessa atividade?',
    label:
      'Essa é uma resposta jurídica, onde deve ser indicada qual base legal trazida pela LGPD é utilizada para justificar a atividade de tratamento de dados descrita. Para saber mais sobre as bases legais, consulte a função “Saiba mais sobre a LGPD” aqui na plataforma ou o seu time jurídico.',
  },
  {
    title: 'Qual é a base legal para o tratamento dos dados sensíveis envolvidos?',
    label:
      'Essa é uma resposta jurídica, onde deve ser indicada qual base legal trazida pela LGPD é utilizada para justificar a atividade de tratamento de dados sensíveis. Dados pessoais sensíveis são dados pessoais que tenham maior potencial de causar discriminação contra seu titular. São eles: dados sobre origem racial ou étnica, convicção religiosa, opinião política, filiação a sindicato ou a organização de caráter religioso, filosófico ou político, dado referente à saúde ou à vida sexual, dado genético ou biométrico (identificadores físicos como rosto ou impressão digital).',
  },
  {
    title: 'Direitos Assegurados aos Titulares',
    label:
      'Aqui devem ser indicados quais dos direitos previstos pela LGPD são assegurados aos titulares de dados da atividade de tratamento descrita. Para saber mais sobre os direitos dos titulares, consulte a função “Saiba mais sobre a LGPD” aqui na plataforma ou o seu time jurídico.',
  },
  {
    title: 'Alguma decisão sobre esta atividade de tratamento é feita de forma automatizada?',
    label:
      'Aqui deve ser indicado se é realizada alguma decisão automatizada na atividade de tratamento descrita. Decisões automatizadas são tomadas sem interferência humana e podem ser processos de seleção, triagens, criação de perfis de titulares, direcionamento de decisões, entre outros.',
  },
];

export const ConsentData: IFunctionsItems[] = [
  {
    title: 'Link para registro do consentimento',
    label:
      'Caso seja indicado que a atividade se justifica pela base legal do consentimento, aqui é o campo para inserir o link para o registro desse consentimento. Caso essa base legal não esteja sendo utilizada, pode preencher com “N/A” (Não aplicável).',
  },
];

export const AccessRightData: IFunctionsItems[] = [
  {
    title: 'Local de armazenamento de dados?',
    label:
      'Aqui é necessário indicar onde os dados da atividade são armazenados para que os titulares possam exercer o seu direito de acesso. É preciso indicar o nome do programa ou meio de armazenamento (ex. Google Drive, gaveteiro físico, rede interna, etc.) e o local específico (ex. Pasta Geral, Sala da Recepção, etc.)',
  },
];
export const ImpactReport: IFunctionsItems[] = [
  {
    title: 'É recomendável a realização do Relatório de Impacto?',
    label:
      'Aqui deve ser indicado se é recomendável ser realizado um relatório de impacto à proteção de dados dessa atividade. Esse relatório é indicado quando a atividade incluir (i) tratamento de dados em grande escala, (ii) tratamento de dados sensíveis, (iii) utilização de novas tecnologias, (iii) impactos ainda não previsíveis sobre os titulares de dados.',
  },
  {
    title: 'Progresso do Relatório',
    label:
      'Caso o relatório de impacto seja recomendável, indicar se ele já foi iniciado ou concluído.',
  },
  {
    title: 'Link/Referência para o Relatório?',
    label:
      'Caso o relatório de impacto seja recomendável e já estiver em andamento ou concluído, indicar aqui o link para o seu local de armazenamento.',
  },
];
export const SecurityIncidentsData: IFunctionsItems[] = [
  {
    title: 'Já ocorreu algum incidente?',
    label:
      'Aqui deve ser indicado se já ocorreu algum incidente de segurança envolvendo a atividade descrita. Incidentes de segurança pode ser qualquer acesso não autorizado ou situação acidental, ou ilícita de destruição, perda, alteração, comunicação ou difusão de dados pessoais.',
  },
  {
    title: 'Link para documentação relativa ao incidente',
    label:
      'Caso algum incidente já tenha ocorrido, aqui deve ser indicado o link para acesso à documentação do ocorrido, incluindo dados envolvidos, titulares afetados e medidas tomadas pela instituição para prevenção e contenção de danos.',
  },
];
export const SimulatorFine = [
  {
    title1: 'Percentual do faturamento:',
    title2: 'Grau leve',
    text1: 'A1) 0,08%',
    text2: 'A2) 0,15%',
    text3:
      'A infração ocasiona lesão ou ofensa a direitos ou interesses de um número reduzido de titulares, com impacto de ordem material ou moral limitado, que pode ser revertido ou compensado com relativa facilidade; ou Envio ou disponibilização de informações ou descumprimento de determinação fora dos prazos ou condições estabelecidos pela ANPD, sem prejuízo direto para o processo de fiscalização ou administrativo sancionador ou para terceiros e que não decorra delitigância de má-fé.',
  },
  {
    title1: 'Percentual do faturamento',
    title2: 'Grau médio',
    text1: 'A1) 0,13%',
    text2: 'A2) 0,50%',
    text3:
      'A infração ocasiona lesão ou ofensa a direitos ou interesses difusos, coletivos ou individuais, que, dadas as circunstâncias do caso, geram impactos aos titulares, de ordem material ou moral,que não se enquadram nos critérios indicados na descrição do graude dano 0, 1 ou 3; ou Dano decorrente do envio de informações intempestivas ou descumprimento intempestivo com prejuízo direto para o processode fiscalização ou administrativo sancionador ou para terceiros eque não decorra de litigância de má-fé.',
  },
  {
    title1: 'Percentual do faturamento',
    title2: 'Grau grave',
    text1: 'A1) 0,45%',
    text2: 'A2) 1,50%',
    text3:
      'A infração ocasiona lesão ou ofensa a direitos ou interesses difusos,coletivos ou individuais, que, dadas as circunstâncias extraordinárias do caso, têm impacto irreversível ou de difícil reversão sobre os titulares afetados, de ordem material ou moral,ocasionando, entre outras situações, discriminação, violação à integridade física, ao direito à imagem e à reputação, fraudes financeiras ou roubo de identidade; ou Danos decorrentes de litigância de má-fé, tais como, entre outras hipóteses previstas na legislação processual, alteração da verdade dos fatos, uso do processo para conseguir objetivo ilegal,resistência injustificada ao andamento do processo, atuação temerária em qualquer ato do processo ou impedimento da atuaçãoda ANPD.',
  },
];

export const tooltipAggravating = [
  'Art. 14. O valor da multa simples será acrescido nos percentuais abaixo, caso incidam as seguintes circunstâncias agravantes:',
  'II - 5% (cinco por cento) para cada caso de reincidência genérica, até o limite de20% (vinte por cento);',
  'III - 20% (vinte por cento) para cada medida de orientação ou preventiva descumprida no processo de fiscalização ou do procedimento preparatório que precedeu o processo administrativo sancionador, até o limite de 80% (oitenta por cento); e',
  'IV - 30% (trinta por cento) para cada medida corretiva descumprida, até o limite de 90% (noventa por cento).',
  '§1º Na hipótese de incidência de mais de um dos incisos deste artigo, deverão ser somados os percentuais relativos a cada fator.',
  '§2º Na hipótese de haver registros computáveis a título de reincidência específica além do suficiente para a incidência do percentual máximo de agravamento previsto no inciso I deste artigo, os excedentes ingressarão na categoria de reincidência genérica, para o acréscimo previsto no inciso II.',
];

export const tooltipMitigating = [
  ' Art. 15. O valor da multa simples será reduzido, nos percentuais abaixo, caso incidam as seguintes circunstâncias atenuantes:',
  'I - nos casos de cessação da infração:',
  ' a) 75% (setenta e cinco por cento), se previamente à instauração de procedimento preparatório pela ANPD;',
  'b) 50% (cinquenta por cento), se após a instauração de procedimento preparatório e até a instauração de processo administrativo sancionador',
  '  c) 30% (trinta por cento), se após a instauração de processo administrativo sancionador e até a prolação da decisão de primeira instância no âmbito do processo administrativo sancionador;',
  '   II - 20% (vinte por cento), nos casos de implementação de política de boas práticas e de governança ou de adoção reiterada e demonstrada de mecanismos e procedimentos internos capazes de minimizar os danos aos titulares, voltados ao tratamento seguro e adequado de dados, até a prolação da decisão de primeira instância no âmbito do  processo administrativo sancionador;',
  'III - 20% (vinte por cento), nos casos em que o infrator tenha comprovado a implementação de medidas capazes de reverter ou mitigar os efeitos da infração sobre os titulares de dados pessoais afetados, previamente à instauração de procedimento preparatório ou processo administrativo sancionador pela ANPD; e',
  ' IV - 5% (cinco por cento), nos casos em que se verifique a cooperação ou boa-fé por parte do infrator.',
  '§ 1º Para efeitos dos incisos I e III deste artigo, não serão consideradas  atenuantes a cessação da infração e a adoção de medidas capazes de reverter ou  mitigar os efeitos da infração decorrentes do mero cumprimento de determinação administrativa ou judicial.',
  '  § 2º Na hipótese de incidência de mais de um dos incisos deste artigo, deverão ser somados os percentuais relativos a cada fator.',
  '§ 3º Cabe ao infrator o ônus de comprovar perante a ANPD o cumprimento dos  requisitos previstos neste artigo.',
];
